import { Link } from "react-router-dom";
import FitImage from "./FitImage";
import SelectMark from "./SelectMark";
import { categoryLabel } from "./Breadcrumbs";

const fmt = (d) => {
  const date = new Date(d);
  return isNaN(date) ? "" : date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

// End-of-article recommendations: ~3 cards, fully clickable, consistent with the site's bordered cards.
const ReadNext = ({ articles = [], currentSlug }) => {
  const seen = new Set([currentSlug]);
  const items = articles.filter((a) => a?.slug && !seen.has(a.slug) && seen.add(a.slug)).slice(0, 3);
  if (items.length === 0) return null;
  return (
    <section className="mt-14 pt-10 border-t border-neutral-200" data-testid="read-next">
      <div className="flex items-baseline justify-between mb-6">
        <h2 className="editorial-caption text-neutral-950">Read Next</h2>
        <Link to="/category/latest" className="text-[11px] font-bold tracking-[0.2em] uppercase text-neutral-500 hover:text-[#7A1921] transition-colors" data-testid="read-next-more">More stories</Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {items.map((a) => (
          <Link key={a.slug} to={`/article/${a.slug}`} className="group block" data-testid={`read-next-${a.slug}`}>
            <FitImage src={a.image_url} alt={a.title} width={600} className="mb-4" imgClassName="group-hover:scale-[1.03] transition-transform duration-500" />
            <span className="editorial-overline text-[0.65rem] block mb-2">{categoryLabel(a.category)}<SelectMark article={a} /></span>
            <h3 className="font-serif text-lg font-semibold text-neutral-950 leading-snug line-clamp-3 group-hover:text-wine-700 transition-colors">{a.title}</h3>
            {a.published_at && <p className="text-neutral-500 text-xs mt-2">{fmt(a.published_at)}</p>}
          </Link>
        ))}
      </div>
    </section>
  );
};

export default ReadNext;
